// src/App.js - Updated with Sessions route
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { canAccessSession } from './supabase';
import healthcareTheme from './theme/muiTheme';
import TeamPage from './components/team/TeamPage';

// Import ResearcherDashboard
import ResearcherDashboard from './components/research/ResearcherDashboard.js';
import ModernPracticeLog from './components/practice/PracticeLog.js';
import GuidedPractices from './components/guided-practices/GuidedPractices.js';
import SessionPage00 from './components/session/SessionPage00.js';
import ContactPage from './components/contact/ContactPage';


// NEW: Import Sessions component for mobile
let Sessions;
try {
  Sessions = require('./components/user-dashboard/Sessions.js').default;
  console.log('✅ Sessions loaded');
} catch (error) {
  console.log('❌ Sessions not found, using fallback');
  Sessions = () => (
    <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'Arial' }}>
      <h2>Sessions</h2>
      <p>Sessions component is missing</p>
      <button onClick={() => window.location.href = '/dashboard'}>Back to Dashboard</button>
    </div>
  );
}

// Only import components that exist
let Home, Login, UserDashboard, SessionPage, SessionPage02, SessionPage03, SessionPage04, SessionPage05;

try {
  Home = require('./components/home/Home.js').default;
  console.log('✅ Home loaded');
} catch (error) {
  console.log('❌ Home not found, using fallback');
  Home = () => (
    <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'Arial' }}>
      <h1>Face Forward Web</h1>
      <p>Welcome to Face Forward Web</p>
      <div style={{ marginTop: '2rem' }}>
        <button 
          onClick={() => window.location.href = '/login'}
          style={{ 
            padding: '1rem 2rem', 
            backgroundColor: '#4285f4', 
            color: 'white', 
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            cursor: 'pointer',
            marginRight: '1rem'
          }}
        >
          Log in as Patient
        </button>
        <button 
          onClick={() => window.location.href = '/researcher-login'}
          style={{ 
            padding: '1rem 2rem', 
            backgroundColor: '#34a853', 
            color: 'white', 
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            cursor: 'pointer'
          }}
        >
          Log in as Researcher
        </button>
      </div>
    </div>
  );
}

let Support;
try {
  Support = require('./components/support/Support.js').default;
  console.log('✅ Support loaded');
} catch (error) {
  console.log('❌ Support not found, using fallback');
  Support = () => (
    <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'Arial' }}>
      <h2>Support</h2>
      <p>Support component is missing</p>
      <button onClick={() => window.location.href = '/home'}>Go Home</button>
    </div>
  );
}

let ParticipateFlyer;
try {
  ParticipateFlyer = require('./components/participate/ParticipateFlyer.js').default;
  console.log('✅ ParticipateFlyer loaded');
} catch (error) {
  console.log('❌ ParticipateFlyer not found, using fallback');
  ParticipateFlyer = () => (
    <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'Arial' }}>
      <h2>Participate/Refer</h2>
      <p>Participate/Refer component is missing</p>
      <button onClick={() => window.location.href = '/home'}>Go Home</button>
    </div>
  );
}

try {
  Login = require('./components/login/Login.js').default;
  console.log('✅ Login loaded');
} catch (error) {
  console.log('❌ Login not found, using fallback');
  Login = () => (
    <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'Arial' }}>
      <h2>Login Page</h2>
      <p>Login component is missing</p>
      <button onClick={() => window.location.href = '/home'}>Go Home</button>
    </div>
  );
}

try {
  UserDashboard = require('./components/user-dashboard/UserDashboard.js').default;
  console.log('✅ UserDashboard loaded');
} catch (error) {
  console.log('❌ UserDashboard not found, using fallback');
  UserDashboard = () => {
    const { user, userProfile, signOut } = useAuth();
    return (
      <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'Arial' }}>
        <h2>Dashboard</h2>
        <p>Welcome, {user?.email}!</p>
        <p>Role: {userProfile?.role}</p>
        <p>UserDashboard component is missing, but you're logged in.</p>
        <button 
          onClick={() => signOut()}
          style={{ 
            padding: '0.5rem 1rem', 
            backgroundColor: '#dc3545', 
            color: 'white', 
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Sign Out
        </button>
      </div>
    );
  };
}

// Try to load session components
try {
  SessionPage = require('./components/session/SessionPage.js').default;
  console.log('✅ SessionPage loaded');
} catch (error) {
  console.log('❌ SessionPage not found, using fallback');
  SessionPage = () => (
    <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'Arial' }}>
      <h2>Session 1</h2>
      <p>Session component is missing</p>
      <button onClick={() => window.location.href = '/dashboard'}>Back to Dashboard</button>
    </div>
  );
}

try {
  SessionPage02 = require('./components/session/SessionPage02.js').default;
  console.log('✅ SessionPage02 loaded');
} catch (error) {
  console.log('❌ SessionPage02 not found, using fallback');
  SessionPage02 = () => (
    <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'Arial' }}>
      <h2>Session 2</h2>
      <p>Session 2 component is missing</p>
      <button onClick={() => window.location.href = '/dashboard'}>Back to Dashboard</button>
    </div>
  );
}

try {
  SessionPage03 = require('./components/session/SessionPage03.js').default;
  console.log('✅ SessionPage03 loaded');
} catch (error) {
  console.log('❌ SessionPage03 not found, using fallback');
  SessionPage03 = () => (
    <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'Arial' }}>
      <h2>Session 3</h2>
      <p>Session 3 component is missing</p>
      <button onClick={() => window.location.href = '/dashboard'}>Back to Dashboard</button>
    </div>
  );
}

try {
  SessionPage04 = require('./components/session/SessionPage04.js').default;
  console.log('✅ SessionPage04 loaded');
} catch (error) {
  console.log('❌ SessionPage04 not found, using fallback');
  SessionPage04 = () => (
    <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'Arial' }}>
      <h2>Session 4</h2>
      <p>Session 4 component is missing</p>
      <button onClick={() => window.location.href = '/dashboard'}>Back to Dashboard</button>
    </div>
  );
}

try {
  SessionPage05 = require('./components/session/SessionPage05.js').default;
  console.log('✅ SessionPage05 loaded');
} catch (error) {
  console.log('❌ SessionPage05 not found, using fallback');
  SessionPage05 = () => (
    <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'Arial' }}>
      <h2>Session 5</h2>
      <p>Session 5 component is missing</p>
      <button onClick={() => window.location.href = '/dashboard'}>Back to Dashboard</button>
    </div>
  );
}

// Simple Loading Component
const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa'
  }}>
    <div style={{
      padding: '2rem',
      textAlign: 'center',
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
    }}>
      <div style={{
        width: '40px',
        height: '40px',
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #4285f4',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        margin: '0 auto 1rem'
      }}></div>
      <p>Loading...</p>
    </div>
  </div>
);

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  console.log('🔒 ProtectedRoute check:', { 
    loading, 
    hasUser: !!user, 
    userEmail: user?.email
  });

  if (loading) {
    console.log('🔒 ProtectedRoute: Auth still loading...');
    return <LoadingSpinner />;
  }

  if (!user) {
    console.log('🔒 ProtectedRoute: No authenticated user, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  console.log('🔒 ProtectedRoute: User authenticated, allowing access');
  return children;
};

const SessionAccessRoute = ({ children, sessionNumber }) => {
  const { user, loading } = useAuth();
  const [checkingAccess, setCheckingAccess] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    let isActive = true;

    const checkSessionAccess = async () => {
      if (loading) {
        return;
      }

      if (!user?.id) {
        if (isActive) {
          setHasAccess(false);
          setCheckingAccess(false);
        }
        return;
      }

      try {
        const allowed = await canAccessSession(user.id, sessionNumber);
        if (isActive) {
          setHasAccess(!!allowed);
        }
      } catch (error) {
        console.error(
          `❌ Failed to validate access for session ${sessionNumber}:`,
          error,
        );
        if (isActive) {
          setHasAccess(false);
        }
      } finally {
        if (isActive) {
          setCheckingAccess(false);
        }
      }
    };

    checkSessionAccess();

    return () => {
      isActive = false;
    };
  }, [loading, user?.id, sessionNumber]);

  if (loading || checkingAccess) {
    return <LoadingSpinner />;
  }

  if (!hasAccess) {
    return (
      <Navigate
        to="/sessions"
        replace
        state={{ lockedSession: sessionNumber }}
      />
    );
  }

  return children;
};

// Public Route Component
const PublicRoute = ({ children }) => {
  const { user, userProfile, loading } = useAuth();

  console.log('🌐 PublicRoute check:', { 
    loading, 
    hasUser: !!user, 
    hasProfile: !!userProfile,
    userEmail: user?.email,
    profileRole: userProfile?.role
  });

  if (loading) {
    console.log('🌐 PublicRoute: Auth loading, showing public content');
    return children;
  }

  if (user && userProfile) {
    const isLoginPage = window.location.pathname.includes('/login');
    if (isLoginPage) {
      console.log('🌐 PublicRoute: User logged in, redirecting to dashboard');
      if (userProfile.role === 'researcher' || userProfile.role === 'admin') {
        return <Navigate to="/research" replace />;
      } else {
        return <Navigate to="/dashboard" replace />;
      }
    }
  }

  console.log('🌐 PublicRoute: Showing public content');
  return children;
};

// Session Test Component
const SessionTest = () => {
  const [sessionInfo, setSessionInfo] = useState('Loading...');
  
  useEffect(() => {
    const testSession = async () => {
      try {
        const { getCurrentSession } = require('./supabase');
        const session = await getCurrentSession();
        
        const info = {
          hasSession: !!session,
          hasUser: !!session?.user,
          userEmail: session?.user?.email,
          sessionExpiry: session?.expires_at,
          accessToken: session?.access_token ? 'Present' : 'Missing',
          refreshToken: session?.refresh_token ? 'Present' : 'Missing',
          localStorage: {
            hasSupabaseAuth: !!localStorage.getItem('supabase.auth.token'),
            authKeys: Object.keys(localStorage).filter(key => key.includes('supabase'))
          }
        };
        
        setSessionInfo(JSON.stringify(info, null, 2));
      } catch (error) {
        setSessionInfo(`Error: ${error.message}`);
      }
    };
    
    testSession();
  }, []);
  
  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', fontFamily: 'Arial' }}>
      <h2>🔍 Session Test</h2>
      <pre style={{ 
        backgroundColor: '#f5f5f5', 
        padding: '1rem', 
        borderRadius: '4px',
        fontSize: '12px',
        overflow: 'auto'
      }}>
        {sessionInfo}
      </pre>
      <button 
        onClick={() => window.location.reload()}
        style={{ 
          marginTop: '1rem',
          padding: '0.5rem 1rem', 
          backgroundColor: '#007bff', 
          color: 'white', 
          border: 'none', 
          borderRadius: '4px' 
        }}
      >
        Refresh Test
      </button>
    </div>
  );
};

// Auth Test Component
const AuthTest = () => {
  const { user, userProfile, loading, error } = useAuth();
  
  return (
    <div style={{ padding: '2rem', maxWidth: '600px', margin: '0 auto', fontFamily: 'Arial' }}>
      <h2>🧪 Auth Test</h2>
      
      <div style={{ marginBottom: '2rem', padding: '1rem', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
        <h3>AuthContext State</h3>
        <p><strong>Loading:</strong> {loading ? 'Yes' : 'No'}</p>
        <p><strong>User:</strong> {user ? user.email : 'None'}</p>
        <p><strong>Profile:</strong> {userProfile ? `${userProfile.role} - ${userProfile.email}` : 'None'}</p>
        <p><strong>Error:</strong> {error || 'None'}</p>
        <p><strong>Supabase Key:</strong> {process.env.REACT_APP_SUPABASE_KEY ? 'Present' : 'Missing'}</p>
        <p><strong>Key Length:</strong> {process.env.REACT_APP_SUPABASE_KEY?.length || 'N/A'}</p>
      </div>

      <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
        <button 
          onClick={() => window.location.href = '/home'}
          style={{ padding: '0.5rem 1rem', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '4px' }}
        >
          Go Home
        </button>
        <button 
          onClick={() => window.location.href = '/login'}
          style={{ padding: '0.5rem 1rem', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px' }}
        >
          Go to Login
        </button>
        <button 
          onClick={() => window.location.href = '/dashboard'}
          style={{ padding: '0.5rem 1rem', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px' }}
        >
          Go to Dashboard
        </button>
        <button 
          onClick={() => window.location.reload()}
          style={{ padding: '0.5rem 1rem', backgroundColor: '#ffc107', color: 'black', border: 'none', borderRadius: '4px' }}
        >
          Reload Page
        </button>
      </div>
    </div>
  );
};

// Logout Component
const LogoutComponent = () => {
  const { signOut } = useAuth();
  
  React.useEffect(() => {
    signOut();
  }, [signOut]);

  return <Navigate to="/login" replace />;
};

// Main App Component
function App() {
  return (
    <ThemeProvider theme={healthcareTheme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route
              path="/home"
              element={
                <PublicRoute>
                  <Home />
                </PublicRoute>
              }
            />
            <Route
              path="/team"
              element={
                <PublicRoute>
                  <TeamPage />
                </PublicRoute>
              }
            />

            <Route path="/auth-test" element={<AuthTest />} />
            <Route path="/session-test" element={<SessionTest />} />

            {/* Login Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/researcher-login" element={<Login />} />

            {/* Protected Routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <UserDashboard />
                </ProtectedRoute>
              }
            />

            {/* NEW: Sessions Route for Mobile */}
            <Route
              path="/sessions"
              element={
                <ProtectedRoute>
                  <Sessions />
                </ProtectedRoute>
              }
            />

            {/* Support Route */}
            <Route
              path="/support"
              element={
                <PublicRoute>
                  <Support />
                </PublicRoute>
              }
            />
            <Route
              path="/participate-flyer"
              element={
                <PublicRoute>
                  <ParticipateFlyer />
                </PublicRoute>
              }
            />

            {/* Contact Route */}
            <Route path="/contact" element={<ContactPage />} />

            {/* Practice Route */}
            <Route
              path="/practice"
              element={
                <ProtectedRoute>
                  <ModernPracticeLog />
                </ProtectedRoute>
              }
            />
            <Route
              path="/session00"
              element={
                <ProtectedRoute>
                  <SessionAccessRoute sessionNumber={0}>
                    <SessionPage00 />
                  </SessionAccessRoute>
                </ProtectedRoute>
              }
            />

            {/* Session Routes */}
            <Route
              path="/session01"
              element={
                <ProtectedRoute>
                  <SessionAccessRoute sessionNumber={1}>
                    <SessionPage />
                  </SessionAccessRoute>
                </ProtectedRoute>
              }
            />

            <Route
              path="/session02"
              element={
                <ProtectedRoute>
                  <SessionAccessRoute sessionNumber={2}>
                    <SessionPage02 />
                  </SessionAccessRoute>
                </ProtectedRoute>
              }
            />

            <Route
              path="/session03"
              element={
                <ProtectedRoute>
                  <SessionAccessRoute sessionNumber={3}>
                    <SessionPage03 />
                  </SessionAccessRoute>
                </ProtectedRoute>
              }
            />

            <Route
              path="/session04"
              element={
                <ProtectedRoute>
                  <SessionAccessRoute sessionNumber={4}>
                    <SessionPage04 />
                  </SessionAccessRoute>
                </ProtectedRoute>
              }
            />

            <Route
              path="/session05"
              element={
                <ProtectedRoute>
                  <SessionAccessRoute sessionNumber={5}>
                    <SessionPage05 />
                  </SessionAccessRoute>
                </ProtectedRoute>
              }
            />

            {/* Research Route */}
            <Route
              path="/research"
              element={
                <ProtectedRoute>
                  <ResearcherDashboard />
                </ProtectedRoute>
              }
            />

            {/* Guided Practices Route */}
            <Route
              path="/guided-practices"
              element={
                <ProtectedRoute>
                  <GuidedPractices />
                </ProtectedRoute>
              }
            />

            {/* Logout */}
            <Route path="/logout" element={<LogoutComponent />} />

            {/* Default redirect */}
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </Router>
      </AuthProvider>

      <style
        dangerouslySetInnerHTML={{
          __html: `
    /* Aggressive mobile viewport fix */
    html {
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
      height: 100% !important;
      overflow-x: hidden !important;
      -webkit-text-size-adjust: 100%;
      -ms-text-size-adjust: 100%;
    }
    
    body {
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
      min-height: 100% !important;
      overflow-x: hidden !important;
      position: relative !important;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
    
    * {
      box-sizing: border-box !important;
    }
    
    /* Specific fix for React root */
    #root {
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
      min-height: 100vh !important;
    }
    
    /* iOS Safari specific fixes */
    @supports (-webkit-touch-callout: none) {
      html, body {
        -webkit-appearance: none !important;
      }
      
      body {
        min-height: -webkit-fill-available !important;
      }
    }
    
    /* Existing spinner animation */
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `,
        }}
      />
    </ThemeProvider>
  );
}

export default App;
